// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import { Sidebar } from "semantic-ui-react";
import { ApplicationFrameContext } from "./ApplicationFrameContext";
import { ApplicationMenu } from "../ApplicationMenu";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ApplicationFrameMenu = props => {
  const {
    children
  } = props;
  const {
    menu: {
      open
    }
  } = React.useContext(ApplicationFrameContext);
  return React.useMemo(() => /*#__PURE__*/_jsxs(Sidebar.Pushable, {
    children: [/*#__PURE__*/_jsx(ApplicationMenu, {}), /*#__PURE__*/_jsx(Sidebar.Pusher, {
      dimmed: open,
      children: children
    })]
  }), [open, children]);
};